var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoMoreData(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 189,
    height: 105.778,
    viewBox: "0 0 189 105.778",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_18526",
    "data-name": "Group 18526",
    transform: "translate(-866 -1501.222)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "warning",
    transform: "translate(924.891 1973.07)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13015",
    "data-name": "Path 13015",
    d: "M33.591-471.663a8.276,8.276,0,0,0-4.374,2.586C28.707-468.444,1.5-423.213.782-421.8a6.508,6.508,0,0,0,4.512,9.2c.536.11,8.763.151,30.057.151,32.079,0,30.236.041,31.791-.8a7.008,7.008,0,0,0,3.178-4.223,6.176,6.176,0,0,0-.44-4.264c-.193-.385-6.6-11.115-14.251-23.853-12.587-20.992-13.976-23.262-14.774-24.046A8.04,8.04,0,0,0,33.591-471.663Zm3.233,4.54a4.1,4.1,0,0,1,.935.674c.275.248,6.328,10.193,14.375,23.606,13.687,22.794,13.921,23.193,13.921,23.895a1.914,1.914,0,0,1-.949,1.747l-.371.289H5.886l-.371-.289a1.914,1.914,0,0,1-.949-1.747c0-.7.234-1.1,13.921-23.895,8.089-13.467,14.1-23.358,14.375-23.606a3.079,3.079,0,0,1,2.655-.963A3.919,3.919,0,0,1,36.823-467.123Z",
    transform: "translate(0 0)",
    fill: "#6f7e8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13016",
    "data-name": "Path 13016",
    d: "M241.306-335.535a2.333,2.333,0,0,0-1.156,1.224q-.144.392-.151,8.5c0,9-.028,8.721.908,9.423a1.67,1.67,0,0,0,1.293.4,1.685,1.685,0,0,0,1.266-.371c.977-.743.949-.371.908-9.657-.041-8.157-.041-8.323-.33-8.694a3.528,3.528,0,0,0-.633-.647A2.552,2.552,0,0,0,241.306-335.535Z",
    transform: "translate(-206.89 -117.433)",
    fill: "#6f7e8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13017",
    "data-name": "Path 13017",
    d: "M234.089-175.681a3.88,3.88,0,0,0-1.94,2.077,2.988,2.988,0,0,0,.867,3.26,2.974,2.974,0,0,0,4.54,0,3.029,3.029,0,0,0,.11-4.471A3.168,3.168,0,0,0,234.089-175.681Z",
    transform: "translate(-199.976 -255.236)",
    fill: "#6f7e8e"
  })), /*#__PURE__*/React.createElement("text", {
    id: "No_More_Data_",
    "data-name": "No More Data!",
    transform: "translate(866 1602)",
    fill: "#434343",
    fontSize: 26,
    fontFamily: "Gotham-Medium, Gotham",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "No More Data!")))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoMoreData);
export default __webpack_public_path__ + "static/media/no-more-data.f6c4183c54cd8047c565564e78831fb3.svg";
export { ForwardRef as ReactComponent };